import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ArticlesConnexes({ currentSlug, category }) {
  const navigate = useNavigate();

  // Base de données articles pour maillage interne intelligent
  const allArticles = {
    'guide-ville': [
      { slug: 'guide-airbnb-verbier', title: 'Guide Airbnb Verbier' },
      { slug: 'guide-airbnb-lausanne', title: 'Guide Airbnb Lausanne' },
      { slug: 'guide-airbnb-geneve', title: 'Guide Airbnb Genève' },
      { slug: 'guide-airbnb-montreux', title: 'Guide Airbnb Montreux' },
      { slug: 'guide-airbnb-crans-montana', title: 'Guide Crans-Montana' }
    ],
    'strategie': [
      { slug: 'avantages-location-saisonniere', title: '10 Avantages Location Saisonnière' },
      { slug: 'location-saisonniere-vs-longue-duree', title: 'Saisonnière vs Longue Durée' },
      { slug: 'estimation-immobiliere-location-saisonniere', title: 'Estimation Immobilière' },
      { slug: 'conciergerie-airbnb-pourquoi-deleguer', title: 'Pourquoi Déléguer à une Conciergerie' },
      { slug: 'pricing-dynamique-airbnb-suisse', title: 'Pricing Dynamique Airbnb' },
      { slug: 'investissement-locatif-airbnb-7-erreurs', title: '7 Erreurs Investissement Airbnb' },
      { slug: 'calcul-rentabilite-airbnb-suisse', title: 'Calcul Rentabilité Airbnb' }
    ],
    'juridique': [
      { slug: 'fiscalite-location-saisonniere-suisse', title: 'Fiscalité Location Saisonnière' },
      { slug: 'reglementation-airbnb-suisse-2025', title: 'Réglementation Airbnb 2025' },
      { slug: 'tva-location-saisonniere-suisse', title: 'TVA Location Saisonnière' },
      { slug: 'taxe-sejour-airbnb-suisse', title: 'Taxe de Séjour Airbnb' },
      { slug: 'deductions-fiscales-airbnb-suisse', title: '12 Déductions Fiscales' }
    ],
    'marketing': [
      { slug: 'photos-airbnb-professionnelles', title: 'Photos Airbnb Pro' },
      { slug: 'algorithme-airbnb-2025', title: 'Algorithme Airbnb 2025' },
      { slug: 'super-host-airbnb-guide-complet', title: 'Super Host : Guide Complet' },
      { slug: 'description-airbnb-optimisee', title: 'Description Airbnb Optimisée' },
      { slug: 'taux-occupation-airbnb-suisse', title: 'Taux Occupation 90%+' }
    ]
  };

  // Sélection intelligente : 3 articles connexes variés
  let articlesToShow = [];
  
  // Déterminer la catégorie de l'article actuel
  let currentCategory = '';
  for (const [cat, articles] of Object.entries(allArticles)) {
    if (articles.some(a => a.slug === currentSlug)) {
      currentCategory = cat;
      break;
    }
  }

  if (currentCategory) {
    // Stratégie : 1 de la même catégorie + 2 d'autres catégories
    const sameCategory = allArticles[currentCategory].filter(a => a.slug !== currentSlug);
    const otherCategories = Object.keys(allArticles).filter(c => c !== currentCategory);
    
    // Prendre 1 article de la même catégorie
    if (sameCategory.length > 0) {
      articlesToShow.push(sameCategory[0]);
    }
    
    // Prendre 1 article de chacune des 2 autres catégories principales
    otherCategories.slice(0, 2).forEach(cat => {
      if (allArticles[cat].length > 0) {
        articlesToShow.push(allArticles[cat][0]);
      }
    });
  } else {
    // Par défaut, articles populaires de catégories différentes
    articlesToShow = [
      allArticles.strategie[0],
      allArticles.juridique[0],
      allArticles.marketing[0]
    ];
  }

  // S'assurer qu'on a 3 articles et qu'aucun n'est l'article actuel
  const filteredArticles = articlesToShow.filter(a => a && a.slug !== currentSlug).slice(0, 3);

  if (filteredArticles.length === 0) return null;

  return (
    <div className="my-16 py-8 border-t-2 border-gray-200">
      <h3 className="text-2xl font-bold text-[#2B2B2B] mb-6">📚 Articles Connexes</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {filteredArticles.map((article) => (
          <Card 
            key={article.slug}
            className="cursor-pointer hover:shadow-lg transition-all duration-300 group"
            onClick={() => navigate(`/blog/${article.slug}`)}
          >
            <CardContent className="p-6">
              <h4 className="font-bold text-[#2B2B2B] mb-3 group-hover:text-[#8A9474] transition-colors">
                {article.title}
              </h4>
              <div className="flex items-center text-[#8A9474] text-sm font-semibold group-hover:translate-x-2 transition-transform">
                <span>Lire l'article</span>
                <ArrowRight className="h-4 w-4 ml-2" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
